import { LayerType } from "../constant/LayerType";
import LayerAdminService from "./LayerAdminService";

export default class OpenRoadsService extends LayerAdminService {
  public async Import(file: File): Promise<any> {
    const formData = new FormData();
    formData.append("uploadedFile", file);
    return this._client
      .post<any>(`${this._endpoint}/${LayerType.OS_OPEN_ROADS}`, formData)
      .then((response) => {
        return response.data;
      });
  }

  public async Revert(): Promise<any> {
    return this._client
      .delete<any>(`${this._endpoint}/${LayerType.OS_OPEN_ROADS}/latest`)
      .then((response) => {
        return response.data;
      });
  }
}
